var map = {
	"./template.betprofessor": 1624,
	"./template.betprofessor.tsx": 1624,
	"./template.betroyale": 1625,
	"./template.betroyale.tsx": 1625,
	"./template.default": 671,
	"./template.default.tsx": 671,
	"./template.juicybet": 1626,
	"./template.juicybet.tsx": 1626,
	"./template.puntcity": 1627,
	"./template.puntcity.tsx": 1627,
	"./template.questbet": 1628,
	"./template.questbet.tsx": 1628,
	"./template.ts": 498,
	"./template.vikingbet": 1629,
	"./template.vikingbet.tsx": 1629,
	"./template.wellbet": 1630,
	"./template.wellbet.tsx": 1630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2466;